import { forwardRef } from "react";

import { menuTypographyProps } from "NavBar/components/NavLink";
import SettingsOptionWrapper from "NavBar/components/settings/SettingsOptionWrapper";
import { menuIconProps } from "NavBar/styleConstants";

import FnrShineButton from "UI/FnrButton3/FnrShineButton";
import FnrContainedIcon from "UI/FnrContainedIcon";
import FnrTypography from "UI/FnrTypography";

import externalNavigate from "Utilities/externalNavigate";

const PublicHomeButton = forwardRef((props, ref) => {
  return (
    <FnrShineButton
      borderRadius={8}
      data-cy="NavBar_PublicHomeButton"
      onClick={() => externalNavigate("/home", "_self")}
      ref={ref}
      {...props}
    >
      <SettingsOptionWrapper>
        <FnrContainedIcon {...menuIconProps} icon="home fas" />
        <FnrTypography {...menuTypographyProps}>
          View public home page
        </FnrTypography>
      </SettingsOptionWrapper>
    </FnrShineButton>
  );
});

export default PublicHomeButton;
